export var valuesTranslationBatchEntryState = ["Waiting", "ReadyForTranslation", "InTranslation", "ExcludedFromTranslation"];
/*

*/ 
//# sourceMappingURL=TranslationBatchEntryState.js.map